// eslint-disable-next-line no-shadow
export enum NodeTypeEnum {
  FRAMEWORK_NODE = 'FRAMEWORK_NODE',
  CONTROL = 'CONTROL',
  GROUP = 'GROUP',
}
